// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"423d2a0a","204":"1e4087d1","253":"016e1234","348":"5416b46b","441":"423d2a0a","483":"4c47615c","621":"20a8b9c0","644":"69892464","684":"423d2a0a","878":"b21a5be1","884":"93cec820"}[chunkId] + ".chunk.css";
};